'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Functions = require('../core/Functions');

var _ActiveElement = require('../core/ActiveElement');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIUnstyledButton',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    'aria-pressed': _react.PropTypes.bool,
    className: _react.PropTypes.string,
    disabled: _react.PropTypes.bool,
    onClick: _react.PropTypes.func,
    onMouseDown: _react.PropTypes.func,
    tabIndex: _react.PropTypes.number,
    type: _react.PropTypes.oneOf(['button', 'reset', 'submit']).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      tabIndex: 0,
      type: 'button',
      onClick: _reactUtils.emptyFunction
    };
  },
  getClassName: function getClassName(_ref) {
    var className = _ref.className;

    return (0, _reactUtils.classNames)('private-button--unstyled', className);
  },
  getTabIndex: function getTabIndex(_ref2) {
    var disabled = _ref2.disabled,
        tabIndex = _ref2.tabIndex;

    return disabled ? -1 : tabIndex;
  },
  blurActiveElement: function blurActiveElement() {
    (0, _ActiveElement.blurActiveElement)();
  },
  handleMouseDown: function handleMouseDown(evt) {
    var onMouseDown = this.props.onMouseDown;


    if (this.props.disabled) {
      evt.stopPropagation();
    }

    (0, _Functions.callIfPossible)(onMouseDown, evt);
  },
  handleClick: function handleClick(event) {
    if (this.props.disabled) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      this.props.onClick(event);
    }
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        disabled = _props.disabled,
        tabIndex = _props.tabIndex,
        rest = _objectWithoutProperties(_props, ['className', 'disabled', 'tabIndex']);

    return _react2.default.createElement('button', _extends({}, rest, {
      'aria-disabled': disabled,
      className: this.getClassName({ className: className }),
      onClick: this.handleClick,
      onMouseDown: this.handleMouseDown,
      tabIndex: this.getTabIndex({ disabled: disabled, tabIndex: tabIndex })
    }));
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/button/UIUnstyledButton.js
// module id = 306
// module chunks = 0